<template>
  <table
    ref="tabla"
    class="ui table celled"
    style="margin: 0 0;"
  >
    <thead>
      <tr>
        <th class="boldFont greyColor">
          <b class="boldFont greyColor">
            Funcionalidad
          </b>
        </th>
        <template v-for="(campo, key) in listaPermisos">
          <slot :name="`HEAD_${key}`" :campo="campo">
            <th :key="key" class="boldFont greyColor" style="text-align:center;">
              <b class="boldFont greyColor">
                {{ campo.name }}
              </b>
            </th>
          </slot>
        </template>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(dato, key) in listaFuncionalidades" :key="key">
        <td style="text-align: left; ">
          <b class="boldFont greyColor">
            {{ dato.name }}
          </b>
        </td>
        <template v-for="campo in listaPermisos">
          <td
            :key="`${dato.value}${campo.value}`"
            class="boldFont greyColor"
            style="text-align:center;"
          >
            <b class="boldFont greyColor">
              <div 
                v-if="existePermiso(`${dato.value}${campo.value}`)"
                class="ui read-only checkbox"
              >
                <input type="checkbox" :checked="tienePermiso(`${dato.value}${campo.value}`)" @click="onClick(`${dato.value}${campo.value}`)" />
                <label>&nbsp;</label>
              </div>
            </b>
          </td>
        </template>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Vue from 'vue';
  import _ from 'lodash';
  import ArraysMixin from '@mixins/Arrays.vue';
  export default {
    mixins: [ ArraysMixin ],
    props: {
      value: {
        type: Array,
        default: () => ([])
      },
    },
    data: function() {
      return {
        listaFuncionalidades: [],
        listaPermisos: []
      };
    },
    computed: {
      ...mapGetters('roles', ['getPermisos']),
    },
    watch: {
      getPermisos(){
          const funcionalidades = this.removeDups(
            this.getPermisos.map(({ funcionalidad }) => funcionalidad)
          ).map((x) => ({ name: _.startCase(x), value: x }));
          Vue.set(this,'listaFuncionalidades',funcionalidades);
          const permisos = this.removeDups(
            this.getPermisos.map(({ nombre }) => nombre)
          ).map((x) => ({ name: _.startCase(x), value: x }));
          Vue.set(this,'listaPermisos',permisos);
      }
    },
    mounted() {
      this.obtenerListaDePermisos();
    },
    methods: {
      ...mapActions('roles', [ 'obtenerListaDePermisos' ]),
      existePermiso(permiso) {
        return this.getPermisos.filter((x) => x.valor === permiso).length > 0;
      },
      tienePermiso(permiso) {
        return this.value && (
          this.value.filter((x) => {
            return x === permiso;
          }).length > 0
        );
      },
      onClick(permiso) {
        let permisos = this.value;
        if(this.tienePermiso(permiso)){
          permisos = permisos.filter( x => x !== permiso);
        } else {
          permisos = [ ...permisos, permiso ];
        }
        this.$emit('input', permisos );
      }
    },
  }
</script>

<style lang="scss" module>
@import '@design';
</style>
